// Simple Pendo Analytics Service
import { createPendoConfigFromByIdentityId } from "../utils/pendoMapper";

declare global {
  interface Window {
    pendo: {
      initialize: (config: any) => void;
      [key: string]: any;
    };
  }
}

export interface PendoConfig {
  visitor: {
    id: string;
    email?: string;
    full_name?: string;
    role?: string;
    facility_name?: string;
    user_type?: string;
    is_practitioner?: boolean;
    first_name?: string;
    last_name?: string;
    version?: string;
  };
  account: {
    id: string;
    name?: string;
    account_type?: string;
    is_paying?: boolean;
    planLevel?: string;
  };
}

export class PendoService {
  /**
   * Create Pendo configuration from directory user and role data using byIdentityId structure
   */
  public createPendoConfig(user: any, selectedRole: any): any {
    // Create proper Pendo config using byIdentityId data
    const config = createPendoConfigFromByIdentityId(user, selectedRole);

    return config;
  }

  /**
   * Initialize Pendo with configuration
   */
  public initialize(config: PendoConfig): void {
    if (typeof window !== "undefined" && window.pendo) {
      try {
        window.pendo.initialize(config);
      } catch (_error) {
        // Silently handle Pendo initialization errors
      }
    }
  }
}

// Export singleton instance
export const pendoService = new PendoService();
